import { MinzeElement } from "minze";

export class TjSearchDesktopWrapper extends MinzeElement {
  attrs = ["data-group-id"];

  html = () => /* html */ `
    <div class="tj-search-container">
      <tj-search-results data-group-id="${this.dataGroupId}"></tj-search-results>
    </div>
  `;

  css = () => `
    :host {
    }
  `;
}
